export default __webpack_public_path__ + "static/media/checkout.9294ee3f.gif";